import { effectHandlers } from './effects'

export const parseAnnouncementEffects = (message) => {
  const effects = []
  const cleanMessage = message.replace(/#(\w+)/g, (match, tag) => {
    if (effectHandlers[tag]) {
      effects.push(tag)
      return ''
    }
    return match
  })
  return { cleanMessage: cleanMessage.trim(), effects }
}
